module.exports = __webpack_public_path__ + "static/media/wtrans_bkz.70e8affc.pdf";